//import MUI
import SurfingIcon from '@mui/icons-material/Surfing';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TextField from '@mui/material/TextField';
import Popover from '@mui/material/Popover';

//Import React Hooks
import { useEffect, useState } from 'react'



//Import created components
import SessionEleve from '../../components/sessioneleve/SessionEleve.jsx'
import AddSession from '../../components/addsession/AddSession.jsx'
import ElevePopover from '../../components/elevepopover/ElevePopover.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getSelectedCreneaux, getFormules, getResa } from "../../store/selectors.js";
import { formulesElevesSlice } from "../../store/formulesElevesSlice.js";

//Utils 
import creneauxSorter from '../../utils/creneaux_sorter.js';

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function Eleve({ eleve, index }) {


    //// ----- popover management
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {

        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'popover-creneau' : undefined;
    //// -- end of popover mgmt



    // set a color for this eleve ; depending on his index in ElevesList (modulo 8):
    let colorIndex = index < 8 ? index + 1 : index - ((8 * Math.trunc(index / 8)) - 1); // 

    const dispatch = useDispatch();
    let formules = useSelector(getFormules);
    const lang = useSelector(getLang) //global state : language

    let selectedCreneaux = useSelector(getSelectedCreneaux);
    // if editResa Mode :
    let allResaInfos = useSelector(getResa);
    let creneauxEleve = []; // list of creneaux for this eleve

    selectedCreneaux.map((creneau) => {
        creneau.eleves.map((rider => {
            if (rider.id === eleve.id) {
                creneauxEleve.push(creneau);  // we add every selected creneau this eleve attend...
                creneauxEleve.sort((c1, c2) => creneauxSorter(c1, c2)); // ... and sort them by date/time
            }
        }))
    });


    function getInfosFormule() {
        if (formules.length <= 0 || formules === undefined) {
            console.log("blocage no formules");
            return ["", ""];
        } //stop function if list is not already filled

        // we limit to 5 creneau max for 1 eleve
        let nb_cours = creneauxEleve.length >= 5 ? 5 : creneauxEleve.length;// we limit the number of cours to 5
        //// --  A faire : gérer nb de cours > 5

        if (nb_cours === 0) {

            dispatch(formulesElevesSlice.actions.setFormulesEleves({ id_eleve: eleve.id, nb_cours: 0, id_formule: 0, nom_formule: "absent", tarif_formule: 0 }));
            return ["-", "-"];
        }
        else {
            let currentFormule = formules.filter((formule) => (formule.nb_cours === nb_cours && formule.activite === "surf" && formule.collectif === true));
            dispatch(formulesElevesSlice.actions.setFormulesEleves({ id_eleve: eleve.id, nb_cours: nb_cours, id_formule: currentFormule[0].id_formule, nom_formule: currentFormule[0].nom_formule, tarif_formule: currentFormule[0].tarif }));
            return [currentFormule[0].nom_formule, currentFormule[0].tarif + ",00 €"];
        }

    }



    return (

        <div className="eleve-line">
            <div className="eleve-line-left">
                <div className="eleve-line-left-prenom">
                    <SurfingIcon className={"surfer-color-" + colorIndex} />
                    <p className={"surfer-border-" + colorIndex}>{eleve.prenom}</p>
                    <MoreVertIcon className="eleve-line-left-menu" onClick={handleClick} />
                </div>
                <Popover
                    className="eleve-popover-root"
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <ElevePopover setAnchorEl={setAnchorEl} eleve={eleve} />
                </Popover>

                <div className="eleve-line-left-resp">
                    <div className="eleve-line-left-sessions">
                        {creneauxEleve.map((session) => (
                            <SessionEleve key={session.creneau.id_creneau} creneau={session.creneau} eleve={eleve} />
                        ))}
                    </div>
                    {allResaInfos.CreneauEleves && allResaInfos.CreneauEleves.length > 0 ? null : <AddSession eleve={eleve} nbcours={creneauxEleve.length} />}
                </div>

            </div>
            <div className="eleve-line-right">
                <TextField
                    className="eleve-line-right-formule"
                    label={translator("Formule", lang, "calendarInput1")}
                    size="small"
                    disabled={getInfosFormule()[0].length < 2}
                    value={getInfosFormule()[0]}
                    InputProps={{
                        readOnly: true,
                    }}
                />

                <TextField
                    className="eleve-line-right-tarif"
                    label={translator("Tarif", lang, "calendarInput2")}
                    size="small"
                    disabled={getInfosFormule()[1].length < 2}
                    value={getInfosFormule()[1]}
                    InputProps={{
                        readOnly: true,
                    }}
                />
            </div>

        </div>
    );
}

export default Eleve;